/*eslint-disable*/
import React, { useState, useEffect } from "react";
import CryptoJS from 'crypto-js';
import clsx from "clsx";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import AlertDialog from "./AlertDialog";
import { DropzoneArea } from "material-ui-dropzone";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import LinearProgress from "@material-ui/core/LinearProgress";
import { uploadFiles } from "../../src/viewer/factoryjs/asset-uploader-factory";
import CircularProgress from "@material-ui/core/CircularProgress";
import Avatar from "@material-ui/core/Avatar";
import ConfirmDialog from "./ConfirmDialog";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { green, pink } from "@material-ui/core/colors";
import whiteImage from '../common/images/white.jpg'
import getProjectDetails from "../common/network/project-container-utils";
import Badge from "@material-ui/core/Badge";
import DoneIcon from "@material-ui/icons/Done";
import {
  guid,
  getUserToken,
  getUserUid,
} from "../../src/viewer/factoryjs/util-factory";
import { postProjectNetwork } from "../../src/viewer/factoryjs/projectlist-network-factory";
import { updateProjectNetwork } from "../../src/viewer/factoryjs/projectlist-network-factory";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  FormLabel,
  FormGroup,
  FormHelperText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import firebase from "../firebase.js";
import AddIcon from "@material-ui/icons/Add";
import { Fab } from "@material-ui/core";
import BeingExpo from "../StallTemplate/BeingExpoTemplate";

const useStyles = makeStyles((theme) => ({
  root: {},
  formControl: {
    width: "100%",
    variant: "outlined",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  shape: {
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40,
  },
  shapeCircle: {
    borderRadius: "50%",
    margin: "10px",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  tab: {
    flexGrow: 1,
  },
  avatarimage: {
    display: "flex",
    justifyContent: "center",
    margin: "20px",
    padding: "10px",
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  green: {
    color: "#fff",
    backgroundColor: green[500],
    margin: "10px",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  dropzonePadding: {
    padding: "20px",
  },
  brochurebutton: {
    margin: "10px",
  },
}));

let imgList = [];
let names = [];
let docid;
let uid;
//globally fetched project json if project available
let globalProjectJson;

// index matters for scenes[0]->images->target && istargetenabled
// or
// index matters for scenes[0]->images->src
// global project scene image
let globalSceneImage = {};

// index matters for scenes[0]->gifs->src
// global project scene gif
let globalSceneGif = {};

const StallDetailedForm = ({ className, redirectBack, ...rest }) => {
  const [stallPreviewLink, setStallPreviewLink] = useState([]);
  const [newArray, setNewArray] = useState([]);
  const [tabValue, setTabValue] = React.useState("1");
  const [generatedLink, setGeneratedLink] = React.useState("");
  const [spin, setSpin] = useState(false);
  // const [isProjectDataFetched, setProjectDataFetched] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [alertDialog, setAlertDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [certificationImage, setCertificationImage] = useState("");
  const [certificationUrl, setCertificationUrl] = useState([]);
  const [Files, setFiles] = useState("");
  const [FilesUrl, setFilesUrl] = useState([]);
  const allInputs = { imgUrl: "" };
  const [stallBanner, setStallBanner] = useState("");
  const [profileCompletion, setProfileCompletion] = useState("");
  const [stallBannerUrl, setStallBannerUrl] = useState(allInputs);
  const [MultipaleProduct, setMultipaleProduct] = useState([]);
  const [values, setValues] = useState({
    projectname: "",
    projectid: "",

    // for being expo
    logo_gif: "",
    desk_logo: "",
    whatsapp: "",
    contactno: "",
    website: "",
    videocall: "",
    facebook: "",
    twitter: "",
    instagram: "",
    youtube: "",
    linkedin: "",
    address_text: "",
    description_text: "",
    imagepanel5: "",
    imagepanel4: "",
    imagepanel3: "",
    imagepanel2: "",
    imagepanel1: "",
    download_brochure3: "",
    download_brochure4: "",
    download_brochure5: "",
    download_brochure1: "",
    download_brochure2: "",
    videopanel: "",
    canvas_address_text: "",
    canvas_description_text: "",
  });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getIndex = (obj, name) => {
    return obj.map((x) => x.name).indexOf(name);
  };

  const setFormData = () => {
    // for being expo
    let projectid = globalProjectJson._id ? globalProjectJson._id : "";
    let projectname = globalProjectJson.projectname
      ? globalProjectJson.projectname
      : "";
    let logo_gif;
    let desk_logo;
    let whatsapp;
    let contactno;
    let website;
    let videocall;
    let facebook;
    let twitter;
    let instagram;
    let youtube;
    let linkedin;
    let address_text;
    let description_text;
    let imagepanel5;
    let imagepanel4;
    let imagepanel3;
    let imagepanel2;
    let imagepanel1;
    let download_brochure3;
    let download_brochure4;
    let download_brochure5;
    let download_brochure1;
    let videopanel;
    let download_brochure2;

    globalProjectJson.scenes[0].gifs.map((obj) => {
      if (obj.name == "logo_gif") {
        logo_gif = obj.src;
        console.log("logo_gif changed", obj.src);
      }
    });

    globalProjectJson.scenes[0].videos.map((obj) => {
      if (obj.name == "videopanel") {
        videopanel = obj.src;
        console.log("videopanel changed", obj.src);
      }
    });
    globalProjectJson.scenes[0].images.map((obj) => {
      
      if (obj.name == "desk_logo") {
        desk_logo = obj.src;
      } else if (obj.name == "whatsapp") {
        whatsapp = obj.target;
      } else if (obj.name == "contactno") {
        contactno = obj.target;
      } else if (obj.name == "website") {
        website = obj.target;
      } else if (obj.name == "videocall") {
        videocall = obj.target;
      } else if (obj.name == "facebook") {
        facebook = obj.target;
      } else if (obj.name == "twitter") {
        twitter = obj.target;
      } else if (obj.name == "instagram") {
        instagram = obj.target;
      } else if (obj.name == "youtube") {
        youtube = obj.target;
      } else if (obj.name == "linkedin") {
        linkedin = obj.target;
      } else if (obj.name == "address_text") {
        address_text = obj.src;
      } else if (obj.name == "description_text") {
        description_text = obj.src;
      } else if (obj.name == "imagepanel1") {
        imagepanel1 = obj.src;
      } else if (obj.name == "imagepanel2") {
        imagepanel2 = obj.src;
      } else if (obj.name == "imagepanel3") {
        imagepanel3 = obj.src;
      } else if (obj.name == "imagepanel4") {
        imagepanel4 = obj.src;
      } else if (obj.name == "imagepanel5") {
        imagepanel5 = obj.src;
      } else if (obj.name == "download_brochure1") {
        download_brochure1 = obj.target;
      } else if (obj.name == "download_brochure2") {
        download_brochure2 = obj.target;
      } else if (obj.name == "download_brochure3") {
        download_brochure3 = obj.target;
      } else if (obj.name == "download_brochure4") {
        download_brochure4 = obj.target;
      } else if (obj.name == "download_brochure5") {
        download_brochure5 = obj.target;
      } else if (obj.name == "logo_gif") {
        logo_gif = obj.src;
      }

    });

    // sceneid = globalProjectJson.scenes[0].sceneid;

    return {
      // for being expo

      projectid: projectid,
      projectname: projectname,
      logo_gif: logo_gif,
      desk_logo: desk_logo,
      whatsapp: whatsapp,
      contactno: contactno,
      website: website,
      videocall: videocall,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      linkedin: linkedin,
      address_text: address_text,
      description_text: description_text,
      imagepanel5: imagepanel5,
      imagepanel4: imagepanel4,
      imagepanel3: imagepanel3,
      imagepanel2: imagepanel2,
      imagepanel1: imagepanel1,
      download_brochure3: download_brochure3,
      download_brochure4: download_brochure4,
      download_brochure5: download_brochure5,
      download_brochure1: download_brochure1,
      download_brochure2: download_brochure2,
      videopanel: videopanel,
    };
  };

  const onUpdateDetails = () => {
    setSpin(true);
    console.log("update details called");
    // 1. manipulation of platinum template obj if project data is available

    //manipulate through state

    // index matters for scenes[0]->images->target && istargetenabled
    // or
    // index matters for scenes[0]->images->src
    // global project scene image

    // index matters for scenes[0]->gifs->src
    // global project scene gif

    BeingExpo.projectname = values.projectname;
    BeingExpo.uid = localStorage.getItem("Uid");
    BeingExpo.sceneid = guid();

    //Being-expo Now project logo and developer logo
    BeingExpo.scenes[0].images.map((imageObj, index) => {
      if (imageObj.name == "desk_logo") {
        if (values.desk_logo) {
          console.log("desk_logo index found", index);
          BeingExpo.scenes[0].images[index].src = values.desk_logo;
        }
      }
      if (imageObj.name == "address_text") {
        if (values.address_text) {
          console.log("address_text index found", index);
          BeingExpo.scenes[0].images[index].src = values.address_text;
        }
      }
      if (imageObj.name == "description_text") {
        if (values.description_text) {
          console.log("description_text index found", index);
          BeingExpo.scenes[0].images[index].src = values.description_text;
        }
      }
      if (imageObj.name == "imagepanel1") {
        if (values.imagepanel1) {
          console.log("imagepanel1 index found", index);
          BeingExpo.scenes[0].images[index].src = values.imagepanel1;
        }
      }
      if (imageObj.name == "imagepanel2") {
        if (values.imagepanel2) {
          console.log("imagepanel2 index found", index);
          BeingExpo.scenes[0].images[index].src = values.imagepanel2;
        }
      }
      if (imageObj.name == "imagepanel3") {
        if (values.imagepanel3) {
          console.log("imagepanel3 index found", index);
          BeingExpo.scenes[0].images[index].src = values.imagepanel3;
        }
      }
      if (imageObj.name == "imagepanel4") {
        if (values.imagepanel4) {
          console.log("imagepanel4 index found", index);
          BeingExpo.scenes[0].images[index].src = values.imagepanel4;
        }
      }
      if (imageObj.name == "imagepanel5") {
        if (values.imagepanel5) {
          console.log("imagepanel5 index found", index);
          BeingExpo.scenes[0].images[index].src = values.imagepanel5;
        }
      }
      if (imageObj.name == "whatsapp") {
        if (values.whatsapp) {
          console.log("whatsapp index found", index);
          BeingExpo.scenes[0].images[
            index
          ].target = `https://api.whatsapp.com/send?phone=${values.whatsapp}`;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "contactno") {
        if (values.contactno) {
          console.log("contactno index found", index);
          BeingExpo.scenes[0].images[index].target = values.contactno;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "website") {
        if (values.website) {
          console.log("website index found", index);
          BeingExpo.scenes[0].images[index].target = values.website;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "videocall") {
          BeingExpo.scenes[0].images[index].target = "melzounite";
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        // if (values.videocall) {
        //   console.log("videocall index found", index);
        //   BeingExpo.scenes[0].images[index].target = values.videocall;
        //   BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        // }
      }
      if (imageObj.name == "facebook") {
        if (values.facebook) {
          console.log("facebook index found", index);
          BeingExpo.scenes[0].images[index].target = values.facebook;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "twitter") {
        if (values.twitter) {
          console.log("twitter index found", index);
          BeingExpo.scenes[0].images[index].target = values.twitter;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "instagram") {
        if (values.instagram) {
          console.log("instagram index found", index);
          BeingExpo.scenes[0].images[index].target = values.instagram;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "youtube") {
        if (values.youtube) {
          console.log("youtube index found", index);
          BeingExpo.scenes[0].images[index].target = values.youtube;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "linkedin") {
        if (values.linkedin) {
          console.log("linkedin index found", index);
          BeingExpo.scenes[0].images[index].target = values.linkedin;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "download_brochure1") {
        if (values.download_brochure1) {
          console.log("download_brochure1 index found", index);
          BeingExpo.scenes[0].images[index].target = values.download_brochure1;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "download_brochure2") {
        if (values.download_brochure2) {
          console.log("download_brochure2 index found", index);
          BeingExpo.scenes[0].images[index].target = values.download_brochure2;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "download_brochure3") {
        if (values.download_brochure3) {
          console.log("download_brochure3 index found", index);
          BeingExpo.scenes[0].images[index].target = values.download_brochure3;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "download_brochure4") {
        if (values.download_brochure4) {
          console.log("download_brochure4 index found", index);
          BeingExpo.scenes[0].images[index].target = values.download_brochure4;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
      if (imageObj.name == "download_brochure5") {
        if (values.download_brochure5) {
          console.log("download_brochure5 index found", index);
          BeingExpo.scenes[0].images[index].target = values.download_brochure5;
          BeingExpo.scenes[0].images[index].isTargetEnabled = true;
        }
      }
    });

    // now for intro video panel  --> Manage Diffrent File Formats -->.mp4 .gif .jpeg .jpg .png
    BeingExpo.scenes[0].videos.map((Obj, index) => {
      if (Obj.name == "videopanel") {
        if (
          values.videopanel.endsWith(".mp4") ||
          values.videopanel.endsWith(".webm") ||
          values.videopanel.endsWith(".mkv") ||
          values.videopanel.endsWith(".mov") ||
          values.videopanel.endsWith(".avi")
        ) {
          console.log("videopanel index found entered");
          console.log(values.videopanel);

          BeingExpo.scenes[0].videos[index].src = values.videopanel;
        } else if (
          values.videopanel.endsWith(".jpg") ||
          values.videopanel.endsWith(".jpeg") ||
          values.videopanel.endsWith(".png")
        ) {
          setAlertDialog({
            ...alertDialog,
            isOpen: true,
            title: "Please Choose Correct Video Format",
            subTitle: "",
          });
          console.log("videopanel entered");
          const imageObj = {
            position: BeingExpo.scenes[0].videos[index].position,
            src: values.videopanel,
            height: BeingExpo.scenes[0].videos[index].height,
            width: BeingExpo.scenes[0].videos[index].width,
            scale: BeingExpo.scenes[0].videos[index].scale,
            depth: BeingExpo.scenes[0].videos[index].depth,
            opacity: BeingExpo.scenes[0].videos[index].opacity,
            enablePopup: BeingExpo.scenes[0].videos[index].enablePopup,
            persistent: BeingExpo.scenes[0].videos[index].persistent,
            name:
              BeingExpo.scenes[0].videos[index].name !== undefined
                ? BeingExpo.scenes[0].videos[index].name
                : "",
          };
          let FinalImageObj = Object.assign({}, imageObj);

          BeingExpo.scenes[0].images.push(FinalImageObj);
          BeingExpo.scenes[0].videos.splice(index, 1);
        } else if (values.videopanel.endsWith(".gif")) {
          console.log("videopanel entered");
          const gifObj = {
            position: BeingExpo.scenes[0].videos[index].position,
            src: values.videopanel,
            height: BeingExpo.scenes[0].videos[index].height,
            width: BeingExpo.scenes[0].videos[index].width,
            scale: BeingExpo.scenes[0].videos[index].scale,
            depth: BeingExpo.scenes[0].videos[index].depth,
            opacity: BeingExpo.scenes[0].videos[index].opacity,
            enablePopup: BeingExpo.scenes[0].videos[index].enablePopup,
            persistent: BeingExpo.scenes[0].videos[index].persistent,
            name:
              BeingExpo.scenes[0].videos[index].name !== undefined
                ? BeingExpo.scenes[0].videos[index].name
                : "",
          };
          let FinalGifObj = Object.assign({}, gifObj);
          BeingExpo.scenes[0].gifs.push(FinalGifObj);
          BeingExpo.scenes[0].videos.splice(index, 1);
        } else {
          BeingExpo.scenes[0].videos.splice(index, 1);
        }
      }
    });

    BeingExpo.scenes[0].gifs.map((gifObj, index) => {
      if (gifObj.name == "logo_gif") {
        if (values.logo_gif.endsWith(".gif")) {
          console.log("logo_gif index found", index);
          BeingExpo.scenes[0].gifs[index].src = values.logo_gif;
        } else if (
          values.logo_gif.endsWith(".jpeg") ||
          values.logo_gif.endsWith(".jpg") ||
          values.logo_gif.endsWith(".png")
        ) {
          const imageObj = {
            position: BeingExpo.scenes[0].gifs[index].position,
            src: values.logo_gif,
            height: BeingExpo.scenes[0].gifs[index].height,
            width: BeingExpo.scenes[0].gifs[index].width,
            scale: BeingExpo.scenes[0].gifs[index].scale,
            isTargetEnabled: BeingExpo.scenes[0].gifs[index].isTargetEnabled,
            target: BeingExpo.scenes[0].gifs[index].target,
            depth: BeingExpo.scenes[0].gifs[index].depth,
            opacity: BeingExpo.scenes[0].gifs[index].opacity,
            enablePopup: BeingExpo.scenes[0].gifs[index].enablePopup,
            triggerTheta: BeingExpo.scenes[0].gifs[index].triggerTheta,
            vicinityEnabled: BeingExpo.scenes[0].gifs[index].vicinityEnabled,
            persistent: BeingExpo.scenes[0].gifs[index].persistent,
            name:  BeingExpo.scenes[0].gifs[index].name
          };
          BeingExpo.scenes[0].images.push(imageObj);
          BeingExpo.scenes[0].gifs.splice(index, 1);
        } else {
          BeingExpo.scenes[0].gifs.splice(index, 1);
        }
      }
    });
    console.log("After updation", BeingExpo);
    BeingExpo._id = values.projectid;
    getUserToken().then((token) => {
      updateProjectNetwork(
        {
          token: token,
          projectid: values.projectid,
        },
        BeingExpo
      ).then(
        (response) => {
          setSpin(false);
          console.log("update details res", response);
          console.log("After updation state", values);

          response.self = true; // set the self property to true as this project belongs to the user.
          //   resolve(response);
        },
        (error) => {
          setSpin(false);
          console.log("update details err", error);
          //   message = "Error: " + error.status + " " + error.statusText;
        }
      );
    });
    // console.log(selectedStallJSON);
  };

  useEffect(() => {
    let currentProjectId = localStorage.getItem("projectId");
    const concatURL = currentProjectId + "vr.melzo.com";
    const encrypted = CryptoJS.AES.encrypt(concatURL, "0DmtozfsHyOlKcbVB4l2sAGJh78HAInz");
    let finalURL = "https://vr.melzo.com/dekho/" + encrypted.toString().replace(/[/]/g, '_');
    setStallPreviewLink(finalURL);
    let FormDetailsObj;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        console.log("current user", user.uid);
        uid = user.uid;
        localStorage.setItem("Uid", user.uid);

        getProjectDetails(currentProjectId, user.uid)
          .then((res) => {
            console.log("project json", res);
            globalProjectJson = res;

            FormDetailsObj = setFormData();
            console.log("form details obj", FormDetailsObj);
            setValues({
              ...values,
              projectid: FormDetailsObj.projectid
                ? FormDetailsObj.projectid
                : "",
              projectname: FormDetailsObj.projectname
                ? FormDetailsObj.projectname
                : "",
              logo_gif: FormDetailsObj.logo_gif ? FormDetailsObj.logo_gif : "",
              desk_logo: FormDetailsObj.desk_logo
                ? FormDetailsObj.desk_logo
                : "",
              whatsapp: FormDetailsObj.whatsapp.split("=")[1]
                ? FormDetailsObj.whatsapp.split("=")[1]
                : "",
              contactno: FormDetailsObj.contactno
                ? FormDetailsObj.contactno
                : "",
              website: FormDetailsObj.website ? FormDetailsObj.website : "",
              videocall: FormDetailsObj.videocall
                ? FormDetailsObj.videocall
                : "",
              facebook: FormDetailsObj.facebook ? FormDetailsObj.facebook : "",
              twitter: FormDetailsObj.twitter ? FormDetailsObj.twitter : "",
              instagram: FormDetailsObj.instagram
                ? FormDetailsObj.instagram
                : "",
              youtube: FormDetailsObj.youtube ? FormDetailsObj.youtube : "",
              linkedin: FormDetailsObj.linkedin ? FormDetailsObj.linkedin : "",
              address_text: FormDetailsObj.address_text
                ? FormDetailsObj.address_text
                : "",
              description_text: FormDetailsObj.description_text
                ? FormDetailsObj.description_text
                : "",
              imagepanel1: FormDetailsObj.imagepanel1
                ? FormDetailsObj.imagepanel1
                : "",
              imagepanel2: FormDetailsObj.imagepanel2
                ? FormDetailsObj.imagepanel2
                : "",
              imagepanel3: FormDetailsObj.imagepanel3
                ? FormDetailsObj.imagepanel3
                : "",
              imagepanel4: FormDetailsObj.imagepanel4
                ? FormDetailsObj.imagepanel4
                : "",
              imagepanel5: FormDetailsObj.imagepanel5
                ? FormDetailsObj.imagepanel5
                : "",
              videopanel: FormDetailsObj.videopanel
                ? FormDetailsObj.videopanel
                : "",
              download_brochure1: FormDetailsObj.download_brochure1
                ? FormDetailsObj.download_brochure1
                : "",
              download_brochure2: FormDetailsObj.download_brochure2
                ? FormDetailsObj.download_brochure2
                : "",
              download_brochure3: FormDetailsObj.download_brochure3
                ? FormDetailsObj.download_brochure3
                : "",
              download_brochure4: FormDetailsObj.download_brochure4
                ? FormDetailsObj.download_brochure4
                : "",
              download_brochure5: FormDetailsObj.download_brochure5
                ? FormDetailsObj.download_brochure5
                : "",
            });
          })
          .catch((err) => {
            console.log(err);
            // setProjectDataFetched(true)
          });
      } else {
        window.location.href = "/";
      }
    });
  }, []);

  const getFileName = (url) => {
    let splitUrl = url.split("/");
    let tempname1 = splitUrl[splitUrl.length - 1];
    let tempname2 = tempname1.split("%20").join("");
    let final = tempname2.split("%24");
    return decodeURI(final[0]);
  };
  //return a promise that resolves with a File instance
  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };
  const setAddressCanvas = () => {
    let c = document.getElementById("address_canvas");

    let image = c.toDataURL("image/jpg");

    // c.toBlob((blob)=>{

    //Usage example:
    urltoFile(image, "canvas_address.jpg", "image/jpg").then(function (file) {
      uploadFiles([file], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            address_text: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Canvas_address Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    });
    // if (blob) {

    //       const myGuid = guid();
    //       const storageUrl = firebase.app().storage('gs://ppt-vr.appspot.com')
    //       const storageRef = storageUrl.ref();

    //       const uploadTask = storageRef.child(myGuid).put(blob)
    //       uploadTask.on('state_changed',
    //           (snapShot) => {
    //               console.log(snapShot)
    //           }, (err) => {
    //               //catches the errors
    //               console.log(err)
    //           }, () => {

    //               firebase
    //                   .app()
    //                   .storage('gs://ppt-vr.appspot.com')
    //                   .ref()
    //                   .child(myGuid)
    //                   .getDownloadURL()
    //                   .then(fireBaseUrl => {
    //                     console.log(fireBaseUrl)
    //                       setValues({
    //                         ...values,
    //                         address_text:fireBaseUrl
    //                       })

    //                   })
    //           })

    //         }
    // })
    // console.log('canvas image',image)
    //   uploadFiles(image, "widgetimage", true)
    //     .then((url) => {
    //       setValues({
    //         ...values,
    //         canvas_address_text: url[0],
    //       });
    //       setAlertDialog({
    //         isOpen: true,
    //         title: "Image Panel1 Saved",
    //       });
    //       console.log("returned url", url[0]);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setSpin(false);
    //     });
  };
  const setDescCanvas = () => {
    let c = document.getElementById("description_canvas");
    let image = c.toDataURL("image/jpg");

    // c.toBlob((blob)=>{

    //Usage example:
    urltoFile(image, "canvas_description.jpg", "image/jpg").then(function (
      file
    ) {
      uploadFiles([file], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            description_text: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Canvas_Description Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    });
  };

  const setAlertDialogfunc = () => {
    setAlertDialog({
      ...alertDialog,
      isOpen: false,
      title: "",
      subTitle: "",
    });
  };

  const classes = useStyles();

  const circle = (
    <div className={clsx(classes.shape, classes.shapeCircle)}>
      <DoneIcon style={{ margin: "7px", color: "white", cursor: "pointer" }} />
    </div>
  );

  const handleChange = (event) => {
    console.log(event.target.name);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleCanvasAddressChange = (event) => {
    let c = document.getElementById("address_canvas");
    let ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    var img = document.getElementById("scream");
    ctx.drawImage(img, 0, 0,c.width, c.height);
    // ctx.font = "20px Georgia";
    
    
    
    let multiText = event.target.value.split("/n");
    ctx.font = "25px Verdana";
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, c.width, 0);
    gradient.addColorStop("0", "magenta");
    gradient.addColorStop("0.5", "blue");
    gradient.addColorStop("1.0", "red");
    // Fill with gradient
    ctx.fillStyle = gradient;
    for (let i = 0; i < multiText.length; i++) {
      ctx.fillText(multiText[i], 10, 35 * (i + 1));
    }

    console.log(event.target.name);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleCanvasDescChange = (event) => {
    let c = document.getElementById("description_canvas");
    let ctx = c.getContext("2d");
    // ctx.clearRect(0, 0, c.width, c.height);
    // var img = document.getElementById("scream");
    // ctx.drawImage(img, 0, 0,c.width, c.height);
    // ctx.font = "20px Georgia";
    // let multiText = event.target.value.split("/n");
    ctx.clearRect(0, 0, c.width, c.height);
    var img = document.getElementById("scream");
    ctx.drawImage(img, 0, 0,c.width, c.height);
    // ctx.font = "20px Georgia";
    
    
    
    let multiText = event.target.value.split("/n");
    ctx.font = "20px Verdana";
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, c.width, 0);
    gradient.addColorStop("0", "magenta");
    gradient.addColorStop("0.5", "blue");
    gradient.addColorStop("1.0", "red");
    // Fill with gradient
    ctx.fillStyle = gradient;
    for (let i = 0; i < multiText.length; i++) {
      ctx.fillText(multiText[i], 10, 35 * (i + 1));
    }

    console.log(event.target.name);
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleCertificationChange = (e) => {
    setCertificationImage(e.target.files[0]);
  };

  const handleImageChange = (e) => {
    console.log("target file", e.target.files[0]);
    if (e.target.files[0] && e.target.files[0].size < 10000000 ) {
      uploadFiles([e.target.files[0]], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            [e.target.name]: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: `${e.target.name} Saved`,
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: `${e.target.name} Size should not be more than 10mb`,
      });
    }
    // if(e.target.files[0].name.endsWith('jpeg') || e.target.files[0].name.endsWith('png') ){
    //   if (e.target.files[0] && e.target.files[0].size < 10000000 ) {
    //     uploadFiles([e.target.files[0]], "widgetimage", true)
    //       .then((url) => {
    //         setValues({
    //           ...values,
    //           [e.target.name]: url[0],
    //         });
    //         setAlertDialog({
    //           isOpen: true,
    //           title: `${e.target.name} Saved`,
    //         });
    //         console.log("returned url", url[0]);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         setSpin(false);
    //       });
    //   } else {
    //     setAlertDialog({
    //       isOpen: true,
    //       title: `${e.target.name} Size should not be more than 10mb`,
    //     });
    //   }
    // }else{

    //   setAlertDialog({
    //     isOpen: true,
    //     title: `Choose png/jpeg format of ${e.target.name} `,
    //   });
    // }
  };

  const handleVideoChange = (e) => {
    console.log("target file", e.target.files[0]);
    // if(e.target.files[0].name.endsWith('.mp4')){
    //   if (e.target.files[0] && e.target.files[0].size < 25000000) {
    //     uploadFiles([e.target.files[0]], "widgetvideo", true)
    //       .then((url) => {
    //         setValues({
    //           ...values,
    //           [e.target.name]: url[0],
    //         });
    //         setAlertDialog({
    //           isOpen: true,
    //           title: `${e.target.name} Saved`,
    //         });
    //         console.log("returned url", url[0]);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         setSpin(false);
    //       });
    //   } else {
    //     setAlertDialog({
    //       isOpen: true,
    //       title: `${e.target.name} Should be less than 25mb`,
    //     });
    //   }
    // }
    // else{
    //   setAlertDialog({
    //     isOpen: true,
    //     title: `Please Choose Mp4 format`,
    //   });
    // }
    if (e.target.files[0] && e.target.files[0].size < 25000000) {
      uploadFiles([e.target.files[0]], "widgetvideo", true)
        .then((url) => {
          setValues({
            ...values,
            [e.target.name]: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: `${e.target.name} Saved`,
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: `${e.target.name} Should be less than 25mb`,
      });
    }
  };

  const uploadIntroVideoPanel = () => {
    if (values.videopanel) {
      uploadFiles([values.videopanel], "widgetvideo", true)
        .then((url) => {
          setValues({
            ...values,
            videopanel: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Intro Video Panel Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Video",
      });
    }
  };

  const handleChangeDropdown = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };
  const uploadDeskLogo = () => {
    if (values.desk_logo.name) {
      uploadFiles([values.desk_logo], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            desk_logo: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Desk Logo Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Desk Logo",
      });
    }
  };

  const uploadLogoGif = () => {
    if (values.logo_gif.name) {
      uploadFiles([values.logo_gif], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            logo_gif: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Logo Gif Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Gif Logo",
      });
    }
  };

  const onUploadBrochure1 = () => {
    if (values.download_brochure1.length) {
      uploadFiles(values.download_brochure1, "widgetdocument", true)
        .then((url) => {
          setValues({
            ...values,
            download_brochure1: `https://pptvr-documents.s3.ap-south-1.amazonaws.com/${url[0]}`,
          });
          setAlertDialog({
            isOpen: true,
            title: "Brochure Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Brochure1",
      });
    }
  };

  const onUploadBrochure2 = () => {
    if (values.download_brochure2.length) {
      uploadFiles(values.download_brochure2, "widgetdocument", true)
        .then((url) => {
          setValues({
            ...values,
            download_brochure2: `https://pptvr-documents.s3.ap-south-1.amazonaws.com/${url[0]}`,
          });
          setAlertDialog({
            isOpen: true,
            title: "Brochure Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Brochure2",
      });
    }
  };

  const onUploadBrochure3 = () => {
    if (values.download_brochure3.length) {
      uploadFiles(values.download_brochure3, "widgetdocument", true)
        .then((url) => {
          setValues({
            ...values,
            download_brochure3: `https://pptvr-documents.s3.ap-south-1.amazonaws.com/${url[0]}`,
          });
          setAlertDialog({
            isOpen: true,
            title: "Brochure Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Brochure3",
      });
    }
  };

  const onUploadBrochure4 = () => {
    if (values.download_brochure4.length) {
      uploadFiles(values.download_brochure4, "widgetdocument", true)
        .then((url) => {
          setValues({
            ...values,
            download_brochure4: `https://pptvr-documents.s3.ap-south-1.amazonaws.com/${url[0]}`,
          });
          setAlertDialog({
            isOpen: true,
            title: "Brochure Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Brochure4",
      });
    }
  };

  const onUploadBrochure5 = () => {
    if (values.download_brochure5.length) {
      uploadFiles(values.download_brochure5, "widgetdocument", true)
        .then((url) => {
          setValues({
            ...values,
            download_brochure5: `https://pptvr-documents.s3.ap-south-1.amazonaws.com/${url[0]}`,
          });
          setAlertDialog({
            isOpen: true,
            title: "Brochure Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Brochure5",
      });
    }
  };

  const uploadImagePanel1 = () => {
    if (values.imagepanel1.name) {
      uploadFiles([values.imagepanel1], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            imagepanel1: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Panel1 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadImagePanel2 = () => {
    if (values.imagepanel2.name) {
      uploadFiles([values.imagepanel2], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            imagepanel2: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Panel2 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadImagePanel3 = () => {
    if (values.imagepanel3.name) {
      uploadFiles([values.imagepanel3], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            imagepanel3: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Panel3 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadImagePanel4 = () => {
    if (values.imagepanel4.name) {
      uploadFiles([values.imagepanel4], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            imagepanel4: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Panel4 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadImagePanel5 = () => {
    if (values.imagepanel5.name) {
      uploadFiles([values.imagepanel5], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            imagepanel5: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Panel5 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadProjectLogo = () => {
    if (values.projectlogo.name) {
      uploadFiles([values.projectlogo], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            projectlogo: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Project Logo Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadIntroPerspectiveGif = () => {
    if (values.inroperspectivegif.name) {
      uploadFiles([values.inroperspectivegif], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            inroperspectivegif: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Image Intro GIF Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadStandeePanel1 = () => {
    if (values.standeepanel1.name) {
      uploadFiles([values.standeepanel1], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            standeepanel1: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Standee Panel 1 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const uploadStandeePanel2 = () => {
    if (values.standeepanel2.name) {
      uploadFiles([values.standeepanel2], "widgetimage", true)
        .then((url) => {
          setValues({
            ...values,
            standeepanel2: url[0],
          });
          setAlertDialog({
            isOpen: true,
            title: "Standee Panel 2 Saved",
          });
          console.log("returned url", url[0]);
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Select Logo",
      });
    }
  };

  const handleDropZoneChangeBrochure1 = (files) => {
    setValues({
      ...values,
      download_brochure1: files,
    });
  };

  const handleDropZoneChangeBrochure2 = (files) => {
    setValues({
      ...values,
      download_brochure2: files,
    });
  };
  const handleDropZoneChangeBrochure3 = (files) => {
    setValues({
      ...values,
      download_brochure3: files,
    });
  };
  const handleDropZoneChangeBrochure4 = (files) => {
    setValues({
      ...values,
      download_brochure4: files,
    });
  };
  const handleDropZoneChangeBrochure5 = (files) => {
    setValues({
      ...values,
      download_brochure5: files,
    });
  };

  const handleFileChangeDropZone = (files) => {
    setFiles(files);
  };

  const onUploadCertificationsWithAWS = () => {
    setSpin(true);
    if (certificationImage.length) {
      uploadFiles(certificationImage, "widgetimage", true)
        .then((url) => {
          const backValue = false;
          const firestore = firebase.firestore();
          firestore
            .collection("users")
            .doc(docid)
            .set(
              {
                certificationsUrl: url,
              },
              { merge: true }
            )
            .then(() => {
              resolve("Done");
              setSpin(false);
            })
            .catch((error) => {
              reject(error);
              setSpin(false);
            });
          setAlertDialog({
            isOpen: true,
            title: "Certification Uploaded",
          });
        })
        .catch((err) => {
          console.log(err);
          setSpin(false);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Add Certificates",
      });
      setSpin(false);
    }
  };

  const logOut = () => {
    console.log("logout click");
    firebase
      .auth()
      .signOut()
      .then((res) => {
        window.location.href = "/";
      });
  };

  const onUploadFilesWithAWS = () => {
    setSpin(true);
    if (Files.length) {
      uploadFiles(Files, "widgetdocument", true)
        .then((url) => {
          const backValue = false;
          const firestore = firebase.firestore();
          firestore
            .collection("users")
            .doc(docid)
            .set(
              {
                fileUrl: url,
              },
              { merge: true }
            )
            .then(() => {
              resolve("Done");
              setSpin(false);
            })
            .catch((error) => {
              reject(error);
              setSpin(false);
            });
          setAlertDialog({
            isOpen: true,
            title: "File Uploaded",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setAlertDialog({
        isOpen: true,
        title: "Please Add Catalogue",
      });
      setSpin(false);
    }
  };

  return (
    <div>
      <img id="scream" src={whiteImage} style={{display:'none'}}></img>
      <form
        autoComplete="off"
        noValidate
        className={clsx(classes.root, className)}
        {...rest}
      >
        <div
          style={{
            position: "sticky",
            top: "0",
            background: "white",
            zIndex: "10000",
          }}
        >
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <CardHeader
              title="Being Exporter Virtual Stall"
              fontWeight="fontWeightBold"
            />
            <div style={{ display: "flex" }}>
              <Button
                color="primary"
                variant="contained"
                style={{
                  height: "45px",
                  alignSelf: "center",
                  marginRight: "15px",
                }}
                onClick={() => window.open(stallPreviewLink,'_blank')}
              >
                View Your Stall
              </Button>
              {spin ? (
                <CircularProgress
                  color="secondary"
                  style={{ margin: "5px", alignSelf: "center" }}
                  size={20}
                />
              ) : (
                ""
              )}

              <Button
                color="primary"
                variant="contained"
                style={{
                  height: "45px",
                  alignSelf: "center",
                  marginRight: "15px",
                }}
                onClick={() => onUpdateDetails()}
              >
                Update Details
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={logOut}
                style={{
                  height: "45px",
                  alignSelf: "center",
                  marginRight: "15px",
                }}
              >
                Log Out
              </Button>
            </div>
          </Box>
          <Divider />
          <TabContext value={tabValue}>
            <AppBar position="relative">
              <TabList onChange={handleTabChange} aria-label="profiletab">
                <Tab label="Stall Primary Data" value="1" />
                <Tab label="Stall Images" value="2" />
                <Tab label="Stall Videos" value="3" />
                {/* <Tab label="Stall Project Selectable" value="4" /> */}
                <Tab label="Stall Documents" value="4" />
                {/* <Tab label="Submit Data" value="5" /> */}
              </TabList>
            </AppBar>
          </TabContext>
        </div>

        <Card>
          <CardContent>
            <div className={classes.tab}>
              <TabContext value={tabValue}>
                <TabPanel value="1">
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        label="Project Name"
                        name="projectname"
                        onChange={handleChange}
                        required
                        value={values.projectname}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        label="Enter Whatsapp Number"
                        name="whatsapp"
                        onChange={handleChange}
                        required
                        value={values.whatsapp}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="number"
                        fullWidth
                        label="Contact Number"
                        name="contactno"
                        onChange={handleChange}
                        required
                        value={values.contactno}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        label="Website Link"
                        name="website"
                        onChange={handleChange}
                        required
                        value={values.website}
                        variant="outlined"
                      />
                    </Grid>

                    {/* <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        label="Video Call Link"
                        name="videocall"
                        onChange={handleChange}
                        required
                        value={values.videocall}
                        variant="outlined"
                        
                      />
                    </Grid> */}

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        label="Facebook Link"
                        name="facebook"
                        onChange={handleChange}
                        required
                        value={values.facebook}
                        variant="outlined"
                      />
                    </Grid>

                    {/* <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        disabled={true}
                        label="Secret Key"
                        name="projectid"
                        onChange={handleChange}
                        required
                        value={values.projectid}
                        variant="outlined"
                      />
                    </Grid> */}

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        label="Twitter"
                        name="twitter"
                        onChange={handleChange}
                        value={values.twitter}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        onChange={handleChange}
                        label="Instagram Link"
                        name="instagram"
                        value={values.instagram}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        label="Youtube Link"
                        name="youtube"
                        value={values.youtube}
                        variant="outlined"
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid item md={12} xs={12}>
                      <TextField
                        type="text"
                        onChange={handleChange}
                        fullWidth
                        label="Linkedin Link"
                        name="linkedin"
                        value={values.linkedin}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        onChange={handleCanvasAddressChange}
                        label="Canvas Address"
                        name="canvas_address_text"
                        // value={values.address_text}
                        value={values.canvas_address_text}
                        variant="outlined"
                        multiline
                        helperText="Max Length : 80 ('type /n to break line'-Text Will be Set in Image)"
                        inputProps={{ maxLength: 80 }}
                      />
                      {/* <Divider/> */}
                      <canvas
                        id="address_canvas"
                        fullwidth
                        style={{ border: "1px solid black" }}
                        width="245"
                        height="150"
                      ></canvas>
                      <br />
                      <Button
                        color="primary"
                        className={classes.brochurebutton}
                        variant="contained"
                        onClick={() => setAddressCanvas()}
                      >
                        Set Address
                      </Button>
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        type="text"
                        fullWidth
                        onChange={handleCanvasDescChange}
                        label="Canvas Description"
                        helperText="Max Length : 120 ('type /n to break line'-Text Will be Set in Image)"
                        name="canvas_description_text"
                        // value={values.description_text}
                        value={values.canvas_description_text}
                        variant="outlined"
                        multiline
                        inputProps={{ maxLength: 120 }}
                      />
                      <canvas
                        id="description_canvas"
                        fullwidth
                        style={{ border: "1px solid black" }}
                        width="245"
                        height="150"
                      ></canvas>

                      <br />
                      <Button
                        color="primary"
                        className={classes.brochurebutton}
                        variant="contained"
                        onClick={() => setDescCanvas()}
                      >
                        Set Description
                      </Button>
                    </Grid>
                  </Grid>
                </TabPanel>

                <TabPanel value="2">
                  <Grid item md={6} xs={12}>
                    <label htmlFor="desk_logo">
                      <input
                        style={{ display: "none" }}
                        id="desk_logo"
                        accept="image/png, image/jpeg"
                        name="desk_logo"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"
                        className={classes.brochurebutton}
                      >
                        <AddIcon /> Upload Desk Logo
                      </Fab>
                    </label>
                    {/* <Badge color="secondary" overlap="circle" onClick={uploadDeveloperLogo}> */}
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadDeskLogo}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Please Maintain Logo Ratio (100px X 55px) </span>
                    {/* <span>{values.desk_logo.name}</span> */}
                  </Grid>
                  {/* <br/> */}

                  <Grid item md={6} xs={12}>
                    <label htmlFor="logo_gif">
                      <input
                        style={{ display: "none" }}
                        id="logo_gif"
                        name="logo_gif"
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        component="span"
                        className={classes.brochurebutton}
                        aria-label="add"
                        variant="extended"
                      >
                        <AddIcon /> Upload Logo PNG/JPEG
                      </Fab>
                    </label>
                    {/* <Badge color="secondary" overlap="circle" onClick={uploadDeveloperLogo}> */}
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadLogoGif}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Upload image in png/jpeg format up to 10MB ratio:(110px X 200px)) </span>
                    {/* <span>{values.logo_gif.name}</span> */}
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <label htmlFor="imagepanel1">
                      <input
                        style={{ display: "none" }}
                        id="imagepanel1"
                        accept="image/png, image/jpeg"
                        name="imagepanel1"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        component="span"
                        className={classes.brochurebutton}
                        aria-label="add"
                        variant="extended"
                      >
                        <AddIcon /> Upload imagepanel1 Logo
                      </Fab>
                    </label>
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadImagePanel1}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Please Maintain Image Ratio (575px X 440px) </span>
                  </Grid>
                  {/* <br/> */}
                  <Grid item md={6} xs={12}>
                    <label htmlFor="imagepanel2">
                      <input
                        style={{ display: "none" }}
                        id="imagepanel2"
                        accept="image/png, image/jpeg"
                        name="imagepanel2"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        className={classes.brochurebutton}
                        component="span"
                        aria-label="add"
                        variant="extended"
                      >
                        <AddIcon /> Upload imagepanel2 Logo
                      </Fab>
                    </label>
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadImagePanel2}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Please Maintain Image Ratio (575px X 440px) </span>
                    {/* <span>{values.imagepanel2.name}</span> */}
                  </Grid>
                  {/* <br/> */}
                  <Grid item md={6} xs={12}>
                    <label htmlFor="imagepanel3">
                      <input
                        style={{ display: "none" }}
                        id="imagepanel3"
                        name="imagepanel3"
                        accept="image/png, image/jpeg"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        className={classes.brochurebutton}
                        component="span"
                        aria-label="add"
                        variant="extended"
                      >
                        <AddIcon /> Upload imagepanel3 Logo
                      </Fab>
                    </label>
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadImagePanel3}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Please Maintain Image Ratio (575px X 440px) </span>
                    {/* <span>{values.imagepanel3.name}</span> */}
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <label htmlFor="imagepanel4">
                      <input
                        style={{ display: "none" }}
                        id="imagepanel4"
                        name="imagepanel4"
                        accept="image/png, image/jpeg"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        component="span"
                        className={classes.brochurebutton}
                        aria-label="add"
                        variant="extended"
                      >
                        <AddIcon /> Upload imagepanel4 Logo
                      </Fab>
                    </label>
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadImagePanel4}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Please Maintain Image Ratio (575px X 440px) </span>
                    {/* <span>{values.imagepanel4.name}</span> */}
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <label htmlFor="imagepanel5">
                      <input
                        style={{ display: "none" }}
                        id="imagepanel5"
                        name="imagepanel5"
                        accept="image/png, image/jpeg"
                        type="file"
                        onChange={handleImageChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        component="span"
                        className={classes.brochurebutton}
                        aria-label="add"
                        variant="extended"
                      >
                        <AddIcon /> Upload imagepanel5 Logo
                      </Fab>
                    </label>
                    {/* <Badge
                      color="secondary"
                      overlap="circle"
                      onClick={uploadImagePanel5}
                    >
                      {circle}
                    </Badge> */}
                    {/* <br /> */}
                    <span>Please Maintain Image Ratio (575px X 440px) </span>
                    {/* <span>{values.imagepanel5.name}</span> */}
                  </Grid>
                  {/* <br/> */}
                </TabPanel>
                <TabPanel value="3">
                  <Grid item md={6} xs={12}>
                    <label htmlFor="videopanel">
                      <input
                        style={{ display: "none" }}
                        id="videopanel"
                        name="videopanel"
                        type="file"
                        accept="video/mp4"
                        onChange={handleVideoChange}
                      />
                      <Fab
                        color="primary"
                        size="small"
                        component="span"
                        aria-label="add"
                        className={classes.brochurebutton}
                        variant="extended"
                      >
                        <AddIcon /> Upload Intro Video
                      </Fab>
                    </label>
                    {/* <Badge
                      color="primary"
                      overlap="circle"
                      onClick={uploadIntroVideoPanel}
                    >
                      {circle}
                    </Badge> */}
                    <br />
                    <span>Please Maintain Video size up to 25mb) </span>
                    {/* <span>{values.videopanel.name}</span> */}
                  </Grid>
                </TabPanel>
                <TabPanel value="4">
                  <Grid
                    container
                    spacing={3}
                    className={classes.dropzonePadding}
                  >
                    <Grid>
                      <Grid item md={12} xs={12}>
                        <DropzoneArea
                          maxFileSize={20000000}
                          filesLimit={1}
                          dropzoneText="Upload  Your  Brochure#1  up  to  1  file  (Supported format : .pdf Max Size : 20mb)  Brochure1's  Link  will  be  visible  in  your  company's  Profile Brochure's will be updated in your stall."
                          acceptedFiles={[".pdf"]}
                          onChange={handleDropZoneChangeBrochure1}
                        />
                        <Button
                          color="primary"
                          className={classes.brochurebutton}
                          variant="contained"
                          onClick={() => onUploadBrochure1()}
                        >
                          Upload Brochure1
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    className={classes.dropzonePadding}
                  >
                    <Grid>
                      <Grid item md={12} xs={12}>
                        <DropzoneArea
                          maxFileSize={20000000}
                          filesLimit={1}
                          dropzoneText="Upload  Your  Brochure#2  up  to  1  file  (Supported format : .pdf Max Size : 20mb)  Brochure2's  Link  will  be  visible  in  your  company's  Profile Brochure's will be updated in your stall."
                          acceptedFiles={[".pdf"]}
                          onChange={handleDropZoneChangeBrochure2}
                        />

                        <Button
                          color="primary"
                          className={classes.brochurebutton}
                          variant="contained"
                          onClick={() => onUploadBrochure2()}
                        >
                          Upload Brochure2
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    className={classes.dropzonePadding}
                  >
                    <Grid>
                      <Grid item md={12} xs={12}>
                        <DropzoneArea
                          maxFileSize={20000000}
                          filesLimit={1}
                          dropzoneText="Upload  Your  Brochure#3  up  to  1  file  (Supported format : .pdf Max Size : 20mb)  Brochure3's  Link  will  be  visible  in  your  company's  Profile Brochure's will be updated in your stall."
                          acceptedFiles={[".pdf"]}
                          onChange={handleDropZoneChangeBrochure3}
                        />

                        <Button
                          color="primary"
                          variant="contained"
                          className={classes.brochurebutton}
                          onClick={() => onUploadBrochure3()}
                        >
                          Upload Brochure3
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    className={classes.dropzonePadding}
                  >
                    <Grid>
                      <Grid item md={12} xs={12}>
                        <DropzoneArea
                          maxFileSize={20000000}
                          filesLimit={1}
                          dropzoneText="Upload  Your  Brochure#4  up  to  1  file  (Supported format : .pdf Max Size : 20mb)  Brochure4's  Link  will  be  visible  in  your  company's  Profile Brochure's will be updated in your stall."
                          acceptedFiles={[".pdf"]}
                          onChange={handleDropZoneChangeBrochure4}
                        />

                        <Button
                          color="primary"
                          variant="contained"
                          className={classes.brochurebutton}
                          onClick={() => onUploadBrochure4()}
                        >
                          Upload Brochure4
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    className={classes.dropzonePadding}
                  >
                    <Grid>
                      <Grid item md={12} xs={12}>
                        <DropzoneArea
                          maxFileSize={20000000}
                          filesLimit={1}
                          dropzoneText="Upload  Your  Brochure#5  up  to  1  file  (Supported format : .pdf Max Size : 20mb)  Brochure5's  Link  will  be  visible  in  your  company's  Profile Brochure's will be updated in your stall."
                          acceptedFiles={[".pdf"]}
                          onChange={handleDropZoneChangeBrochure5}
                        />

                        <Button
                          color="primary"
                          variant="contained"
                          className={classes.brochurebutton}
                          onClick={() => onUploadBrochure5()}
                        >
                          Upload Brochure5
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value="5"></TabPanel>
              </TabContext>
            </div>
          </CardContent>
          <Divider />
        </Card>
      </form>

      <AlertDialog
        alertDialog={alertDialog}
        setAlertDialog={setAlertDialogfunc}
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
};

StallDetailedForm.propTypes = {
  className: PropTypes.string,
};

export default StallDetailedForm;
